import { useEffect, useState } from 'react';

/**
 * decrement the seconds every second
 */
export default function useInterval(isStarted: boolean, initialSeconds = 60) {
  const [seconds, setSeconds] = useState(initialSeconds);

  const reset = () => {
    setSeconds(initialSeconds);
  };

  useEffect(() => {
    if (isStarted) {
      const interval = setTimeout(() => {
        if (seconds <= 0) {
          clearTimeout(interval);
          return;
        }
        setSeconds(seconds - 1);
      }, 1000);
      return () => clearTimeout(interval);
    }
  }, [isStarted, seconds]);

  return { seconds, reset };
}
